<template>
  <div>
    <div v-if="!pages.length">
      <div style="text-align: center; color: red; padding: 48px 16px;">
        No pages to display.
      </div>
    </div>

    <v-layout v-else row wrap class="files-toolbar mb-2" align-center>
      <v-btn
        small
        outline
        color="success"
        class="files-toolbar-btn ma-0 mr-2"
        @click="$emit('clear')"
      >
        Clear
      </v-btn>
      <v-btn
        small
        outline
        color="success"
        class="files-toolbar-btn ma-0 mr-2"
        @click="$emit('select-all')"
      >
        Select all
      </v-btn>
      <v-spacer></v-spacer>
    </v-layout>

    <v-layout row wrap>
      <v-flex
        v-for="page in pages"
        :key="page.key"
        class="files-page-col pa-2"
        style="flex-basis: 20% !important; max-width: 500px !important;"
      >
        <v-card
          class="files-page-card"
          :class="{
            'files-page-card--selected': isSelected(page),
            'files-page-card--linked': page.linkedDocument,
          }"
          :title="page.linkedDocument ? getLinkedDocumentHoverText(page) : ''"
          @click.native="handlePageClick(page)"
        >
          <div
            class="files-page-preview"
            :class="{ 'files-page-preview--linked': page.linkedDocument }"
          >
            <div class="files-page-index">
              {{ page.index }}
            </div>
            <v-icon
              v-if="isSelected(page)"
              class="files-page-check"
              color="success"
            >
              mdi-check-circle
            </v-icon>
            <div v-if="page.linkedDocument" class="files-page-linked-overlay">
              <div class="files-page-linked-badge">
                <v-icon small color="white">mdi-link-variant</v-icon>
                Linked
              </div>
              <div
                v-if="getLinkedDocument(page)"
                class="files-page-linked-overlay-details"
              >
                <div class="files-page-linked-overlay-row">
                  <v-icon small color="white">mdi-file-document-outline</v-icon>
                  <span>{{ getLinkedDocument(page).docTypeID }}</span>
                </div>
                <div
                  v-if="getLinkedDocument(page).studentID"
                  class="files-page-linked-overlay-row"
                >
                  <v-icon small color="white">mdi-account-outline</v-icon>
                  <span>{{ getLinkedDocument(page).studentName }}</span>
                </div>
                <div class="files-page-linked-overlay-row">
                  <v-icon small color="white"
                    >mdi-account-circle-outline</v-icon
                  >
                  <span>{{ getLinkedDocument(page).createdBy || "-" }}</span>
                </div>
                <div class="files-page-linked-overlay-row">
                  <v-icon small color="white">mdi-calendar-outline</v-icon>
                  <span>{{
                    new Date(
                      getLinkedDocument(page).dateUploaded
                    ).toLocaleDateString() || "-"
                  }}</span>
                </div>
              </div>
            </div>
            <pdf
              v-if="page.kind === 'pdf'"
              class="files-thumb"
              :src="page.src"
              :page="page.pageNumber"
              :rotate="getPageRotation(page)"
            ></pdf>
            <img
              v-else
              class="files-thumb-image"
              :src="page.src"
              :alt="page.fileName"
              :style="getImageRotationStyle(page)"
            />
          </div>
          <v-card-text class="files-page-footer pa-2">
            <div>
              <v-btn
                title="Open original file"
                icon
                class="files-page-open"
                @click.stop="openFile(page.fileURL, page.pageNumber, page.kind)"
              >
                <v-icon small color="success">mdi-eye</v-icon>
              </v-btn>
              <v-btn
                title="Rotate page"
                icon
                class="files-page-open"
                @click.stop="rotatePage(page)"
              >
                <v-icon small color="success">mdi-rotate-right</v-icon>
              </v-btn>
            </div>
            <div class="files-page-footer-text">
              <div class="caption grey--text">
                <span>{{ page.fileName }}</span>
                <span style="float: right;">Page {{ page.pageNumber }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="previewDialog" max-width="1100">
      <v-card>
        <v-card-title class="py-0 px-1">
          <v-spacer></v-spacer>
          <v-btn icon class="py-0" @click="openFileInNewTab(previewUrl)"
            ><v-icon color="success">mdi-open-in-new</v-icon></v-btn
          >
          <v-btn icon class="py-0" @click="previewDialog = false">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <iframe
            v-if="previewUrl"
            :src="previewUrl"
            style="width: 100%; height: 80vh; border: 0;"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import pdf from "vue-pdf";

export default {
  name: "DocumentSplitterPageGrid",
  components: {
    pdf,
  },
  props: {
    pages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      pageViewState: {},
      previewDialog: false,
      previewUrl: "",
    };
  },
  methods: {
    ensurePageViewState(page) {
      if (!this.pageViewState[page.key]) {
        this.$set(this.pageViewState, page.key, {
          rotation: 0,
        });
      }

      return this.pageViewState[page.key];
    },
    getImageRotationStyle(page) {
      const state = this.ensurePageViewState(page);
      return {
        transform: "rotate(" + state.rotation + "deg)",
        transformOrigin: "center center",
      };
    },
    getPageRotation(page) {
      const state = this.ensurePageViewState(page);
      return state.rotation;
    },

    rotatePage(page) {
      const state = this.ensurePageViewState(page);
      state.rotation = (state.rotation + 90) % 360;
      this.$emit("rotation-change", {
        key: page.key,
        rotation: state.rotation,
      });
    },
    isSelected(page) {
      return this.selectedKeys.indexOf(page.key) !== -1;
    },
    getLinkedDocument(page) {
      if (!page || !page.linkedDocument) {
        return null;
      }

      if (typeof page.linkedDocument === "object") {
        return page.linkedDocument;
      }

      if (typeof page.linkedDocument === "string") {
        try {
          return JSON.parse(page.linkedDocument);
        } catch (e) {
          return null;
        }
      }

      return null;
    },
    getLinkedDocumentHoverText(page) {
      const linkedDocument = this.getLinkedDocument(page);
      return (
        "Document is linked to account: " +
        (linkedDocument.accountID || "-") +
        ", type: " +
        (linkedDocument.docTypeID || "-")
      );
    },
    async openFile(fileURL, pageNumber, kind) {
      this.previewUrl = "";
      await this.$nextTick();
      this.previewUrl = fileURL + "#page=" + pageNumber;
      this.previewDialog = true;
    },
    openFileInNewTab(fileURL) {
      window.open(fileURL, "_blank");
    },
    handlePageClick(page) {
      if (page.linkedDocument) {
        return;
      }
      this.$emit("toggle", page);
    },
  },
};
</script>
<style>
.files-body {
  background-color: #eee;
}

.files-toolbar-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.files-page-col {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  width: auto !important;
}

.files-page-card {
  cursor: pointer;
  border-color: #ccf1ce !important;
  height: 100%;
  width: 100%;
  border: 2px solid;
  border-radius: 8px !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.files-page-card:hover {
  border-color: #a5d6a7 !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.16) !important;
  transform: translateY(-1px);
}

.files-page-card--selected {
  border-color: #4caf50;
  box-shadow: 0 0 0 1px #4caf50, 0 4px 12px rgba(76, 175, 80, 0.2) !important;
}

.files-page-card--linked {
  cursor: not-allowed !important;
  opacity: 0.85;
  border-color: #ffe082 !important;
}

.files-page-card--linked:hover {
  border-color: #ffd54f !important;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.2) !important;
}

.files-page-preview {
  position: relative;
  background: #f7f8f7;
  overflow: hidden;
  flex: 1 1 auto;
}

.files-page-preview--linked .files-thumb,
.files-page-preview--linked .files-thumb-image {
  opacity: 0.55;
  filter: grayscale(0.6);
}

.files-page-index {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  background: rgba(46, 125, 50, 0.88);
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
}

.files-page-linked-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  background: linear-gradient(
    180deg,
    rgba(28, 28, 32, 0.35) 0%,
    rgba(18, 18, 22, 0.6) 100%
  ) !important;
  color: #fff;
  text-align: center;
  pointer-events: none;
}

.files-page-linked-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #42a5f5, #1e88e5);
  box-shadow: 0 3px 10px rgba(30, 136, 229, 0.5);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.files-page-linked-overlay-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(15, 15, 18, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 92%;
}

.files-page-linked-overlay-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.files-page-check {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  background: #fff;
  border-radius: 50%;
}

.files-thumb {
  display: block;
  width: 100%;
}

.files-thumb .annotationLayer,
.files-thumb .annotationLayer a {
  pointer-events: none !important;
}

.files-thumb-image {
  display: block;
  width: 100%;
  height: auto;
}

.files-page-footer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-top: auto;
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.files-page-footer-text {
  min-width: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.files-page-open {
  flex: 0 0 auto;
  margin: 0;
}
</style>
